import { render, staticRenderFns } from "./crearVigilante.vue?vue&type=template&id=5ee09a88&scoped=true"
import script from "./crearVigilante.vue?vue&type=script&lang=js"
export * from "./crearVigilante.vue?vue&type=script&lang=js"
import style0 from "./crearVigilante.vue?vue&type=style&index=0&id=5ee09a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee09a88",
  null
  
)

export default component.exports